import React, { useState, useEffect } from 'react';
import axios from 'axios';


const API_URL = process.env.REACT_APP_API_URL;
const PaymentSettingsManagement = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState('exchange-rate');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/admin/payments/settings`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setSettings(response.data);
    } catch (err) {
      console.error('Error fetching settings:', err);
      alert('設定の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (section, data) => {
    try {
      setSaving(true);
      const updateData = { [section]: data };
      console.log("======,", updateData);
      await axios.put(`${API_URL}/api/admin/payments/settings`, updateData, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      
      alert('設定を保存しました');
      fetchSettings();
    } catch (err) {
      console.error('Error saving settings:', err);
      alert('設定の保存に失敗しました');
    } finally {
      setSaving(false);
    }
  };

  const calculateRate = (yen, points) => {
    if (yen === 0) return 0;
    return (points / yen).toFixed(4);
  };

  if (loading) return <div>読み込み中...</div>;

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', padding: 20 }}>
      <h2>支払い設定管理</h2>

      {/* Tab Navigation */}
      <div style={{ 
        display: 'flex', 
        gap: '10px', 
        marginBottom: '20px',
        borderBottom: '2px solid #dee2e6'
      }}>
        <button 
          onClick={() => setActiveTab('exchange-rate')}
          style={{
            background: activeTab === 'exchange-rate' ? '#3498db' : '#f8f9fa',
            color: activeTab === 'exchange-rate' ? 'white' : '#495057',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '4px 4px 0 0',
            cursor: 'pointer'
          }}
        >
          為替レート
        </button>
        {/* <button 
          onClick={() => setActiveTab('bank-transfer')}
          style={{
            background: activeTab === 'bank-transfer' ? '#3498db' : '#f8f9fa',
            color: activeTab === 'bank-transfer' ? 'white' : '#495057',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '4px 4px 0 0',
            cursor: 'pointer'
          }}
        >
          銀行振込設定
        </button> */}
        <button 
          onClick={() => setActiveTab('smart-pit')}
          style={{
            background: activeTab === 'smart-pit' ? '#3498db' : '#f8f9fa',
            color: activeTab === 'smart-pit' ? 'white' : '#495057',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '4px 4px 0 0',
            cursor: 'pointer'
          }}
        >
          Smart Pit設定
        </button>
        <button 
          onClick={() => setActiveTab('general')}
          style={{
            background: activeTab === 'general' ? '#3498db' : '#f8f9fa',
            color: activeTab === 'general' ? 'white' : '#495057',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '4px 4px 0 0',
            cursor: 'pointer'
          }}
        >
          一般設定
        </button>
      </div>

      {/* Exchange Rate Tab */}
      {activeTab === 'exchange-rate' && (
        <ExchangeRateSettings 
          settings={settings} 
          onSave={handleSave} 
          saving={saving}
          calculateRate={calculateRate}
        />
      )}

      {/* Bank Transfer Tab */}
      {activeTab === 'bank-transfer' && (
        <BankTransferSettings 
          settings={settings} 
          onSave={handleSave} 
          saving={saving}
        />
      )}

      {/* Smart Pit Tab */}
      {activeTab === 'smart-pit' && (
        <SmartPitSettings 
          settings={settings} 
          onSave={handleSave} 
          saving={saving}
        />
      )}

      {/* General Settings Tab */}
      {activeTab === 'general' && (
        <GeneralSettings 
          settings={settings} 
          onSave={handleSave} 
          saving={saving}
        />
      )}
    </div>
  );
};

// Exchange Rate Settings Component
const ExchangeRateSettings = ({ settings, onSave, saving, calculateRate }) => {
  const [formData, setFormData] = useState({
    yenAmount: settings?.exchangeRate?.yenAmount || 1000,
    pointAmount: settings?.exchangeRate?.pointAmount || 500,
    isActive: settings?.exchangeRate?.isActive ?? true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave('exchangeRate', formData);
  };

  return (
    <div style={{ background: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #dee2e6' }}>
      <h3>為替レート設定</h3>
      
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              日本円金額:
            </label>
            <input 
              type="number" 
              value={formData.yenAmount} 
              onChange={e => setFormData({...formData, yenAmount: parseInt(e.target.value) || 0})}
              min="1"
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
              required
            />
          </div>
          
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              ポイント数:
            </label>
            <input 
              type="number" 
              value={formData.pointAmount} 
              onChange={e => setFormData({...formData, pointAmount: parseInt(e.target.value) || 0})}
              min="1"
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
              required
            />
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input 
              type="checkbox" 
              checked={formData.isActive} 
              onChange={e => setFormData({...formData, isActive: e.target.checked})}
            />
            有効にする
          </label>
        </div>

        {/* Preview */}
        <div style={{ 
          background: '#f8f9fa', 
          padding: '20px', 
          borderRadius: '4px', 
          marginBottom: '20px',
          border: '1px solid #e9ecef'
        }}>
          <h4 style={{ margin: '0 0 15px 0' }}>プレビュー</h4>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#27ae60' }}>
                {formData.yenAmount.toLocaleString()}円
              </div>
              <div style={{ fontSize: '14px', color: '#7f8c8d' }}>日本円</div>
            </div>
            <div style={{ fontSize: '20px', color: '#7f8c8d' }}>=</div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#e67e22' }}>
                {formData.pointAmount.toLocaleString()}ポイント
              </div>
              <div style={{ fontSize: '14px', color: '#7f8c8d' }}>ポイント</div>
            </div>
          </div>
          <div style={{ textAlign: 'center', marginTop: '15px', fontSize: '14px', color: '#7f8c8d' }}>
            レート: 1円 = {calculateRate(formData.yenAmount, formData.pointAmount)}ポイント
          </div>
        </div>

        <button 
          type="submit"
          disabled={saving}
          style={{
            background: saving ? '#95a5a6' : '#27ae60',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '4px',
            cursor: saving ? 'not-allowed' : 'pointer',
            fontSize: '16px'
          }}
        >
          {saving ? '保存中...' : '保存'}
        </button>
      </form>
    </div>
  );
};

// Bank Transfer Settings Component
const BankTransferSettings = ({ settings, onSave, saving }) => {
  const [formData, setFormData] = useState({
    accountName: settings?.bankTransfer?.accountName || '',
    accountNumber: settings?.bankTransfer?.accountNumber || '',
    bankName: settings?.bankTransfer?.bankName || '',
    branchName: settings?.bankTransfer?.branchName || '',
    accountType: settings?.bankTransfer?.accountType || '',
    isActive: settings?.bankTransfer?.isActive ?? true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave('bankTransfer', formData);
  };

  return (
    <div style={{ background: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #dee2e6' }}>
      <h3>銀行振込設定</h3>
      
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              口座名義:
            </label>
            <input 
              type="text" 
              value={formData.accountName} 
              onChange={e => setFormData({...formData, accountName: e.target.value})}
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
              required
            />
          </div>
          
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              口座番号:
            </label>
            <input 
              type="text" 
              value={formData.accountNumber} 
              onChange={e => setFormData({...formData, accountNumber: e.target.value})}
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
              required
            />
          </div>
          
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              銀行名:
            </label>
            <input 
              type="text" 
              value={formData.bankName} 
              onChange={e => setFormData({...formData, bankName: e.target.value})}
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
              required
            />
          </div>
          
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              支店名:
            </label>
            <input 
              type="text" 
              value={formData.branchName} 
              onChange={e => setFormData({...formData, branchName: e.target.value})}
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
              required
            />
          </div>
          
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              口座種別:
            </label>
            <input 
              type="text" 
              value={formData.accountType} 
              onChange={e => setFormData({...formData, accountType: e.target.value})}
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
              required
            />
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input 
              type="checkbox" 
              checked={formData.isActive} 
              onChange={e => setFormData({...formData, isActive: e.target.checked})}
            />
            有効にする
          </label>
        </div>

        <button 
          type="submit"
          disabled={saving}
          style={{
            background: saving ? '#95a5a6' : '#27ae60',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '4px',
            cursor: saving ? 'not-allowed' : 'pointer',
            fontSize: '16px'
          }}
        >
          {saving ? '保存中...' : '保存'}
        </button>
      </form>
    </div>
  );
};

// Smart Pit Settings Component
const SmartPitSettings = ({ settings, onSave, saving }) => {
  const [formData, setFormData] = useState({
    smartPitId: settings?.smartPit?.smartPitId || '',
    apiKey: settings?.smartPit?.apiKey || '',
    isActive: settings?.smartPit?.isActive ?? true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave('smartPit', formData);
  };

  return (
    <div style={{ background: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #dee2e6' }}>
      <h3>Smart Pit設定</h3>
      
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Smart Pit ID:
          </label>
          <input 
            type="text" 
            value={formData.smartPitId} 
            onChange={e => setFormData({...formData, smartPitId: e.target.value})}
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
            required
          />
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            API Key:
          </label>
          <input 
            type="password" 
            value={formData.apiKey} 
            onChange={e => setFormData({...formData, apiKey: e.target.value})}
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
            required
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input 
              type="checkbox" 
              checked={formData.isActive} 
              onChange={e => setFormData({...formData, isActive: e.target.checked})}
            />
            有効にする
          </label>
        </div>

        <button 
          type="submit"
          disabled={saving}
          style={{
            background: saving ? '#95a5a6' : '#27ae60',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '4px',
            cursor: saving ? 'not-allowed' : 'pointer',
            fontSize: '16px'
          }}
        >
          {saving ? '保存中...' : '保存'}
        </button>
      </form>
    </div>
  );
};

// General Settings Component
const GeneralSettings = ({ settings, onSave, saving }) => {
  const [formData, setFormData] = useState({
    minimumPurchase: settings?.minimumPurchase || 1000,
    maximumPurchase: settings?.maximumPurchase || 100000,
    bankTransferBalance: settings?.bankTransferBalance || 0
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave('general', formData);
  };

  return (
    <div style={{ background: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #dee2e6' }}>
      <h3>一般設定</h3>
      
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              最小購入金額 (円):
            </label>
            <input 
              type="number" 
              value={formData.minimumPurchase} 
              onChange={e => setFormData({...formData, minimumPurchase: parseInt(e.target.value) || 0})}
              min="100"
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
              required
            />
          </div>
          
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              最大購入金額 (円):
            </label>
            <input 
              type="number" 
              value={formData.maximumPurchase} 
              onChange={e => setFormData({...formData, maximumPurchase: parseInt(e.target.value) || 0})}
              min="1000"
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
              required
            />
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            銀行振込残高 (円):
          </label>
          <input 
            type="number" 
            value={formData.bankTransferBalance} 
            onChange={e => setFormData({...formData, bankTransferBalance: parseInt(e.target.value) || 0})}
            min="0"
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
            required
          />
          <small style={{ color: '#7f8c8d' }}>
            手動で更新する銀行振込の残高
          </small>
        </div>

        <button 
          type="submit" 
          disabled={saving}
          style={{
            background: saving ? '#95a5a6' : '#27ae60',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '4px',
            cursor: saving ? 'not-allowed' : 'pointer',
            fontSize: '16px'
          }}
        >
          {saving ? '保存中...' : '保存'}
        </button>
      </form>
    </div>
  );
};

export default PaymentSettingsManagement; 